var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlugFill(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.5 0C4.70711 0 4.875 0.167893 4.875 0.375V2.25H7.125V0.375C7.125 0.167893 7.29289 0 7.5 0C7.70711 0 7.875 0.167893 7.875 0.375V2.25H8.625C8.83211 2.25 9 2.41789 9 2.625V4.875C9 6.32475 7.82475 7.5 6.375 7.5C6.3734 7.82545 6.36683 8.1334 6.34453 8.41443C6.3139 8.80028 6.2507 9.16719 6.10701 9.4833C5.95823 9.81063 5.72594 10.0768 5.37965 10.2538C5.04383 10.4255 4.62674 10.5 4.125 10.5C3.37684 10.5 2.91774 10.7475 2.64421 11.0382C2.36234 11.3378 2.25 11.7121 2.25 12H1.5C1.5 11.5379 1.67414 10.9747 2.098 10.5243C2.53021 10.065 3.19611 9.75 4.125 9.75C4.56076 9.75 4.84679 9.6839 5.03832 9.58601C5.21937 9.49347 5.33865 9.36124 5.42424 9.17295C5.51492 8.97344 5.56891 8.70753 5.59688 8.3551C5.6171 8.10033 5.62278 7.81694 5.62438 7.5C4.17492 7.49966 3 6.32454 3 4.875V2.625C3 2.41789 3.16789 2.25 3.375 2.25H4.125V0.375C4.125 0.167893 4.29289 0 4.5 0Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlugFill);
export default __webpack_public_path__ + "static/media/plug-fill.055d2c7997960aa44ec9466fe94b792b.svg";
export { ForwardRef as ReactComponent };